import * as React from 'react'

import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '@/shared/utils/helpers'

export const Tabs = ({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) => {
	return (
		<TabsPrimitive.Root
			data-slot="tabs"
			className={cn('flex flex-col gap-2', className)}
			{...props}
		/>
	)
}

export const TabsList = ({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.List>) => {
	return (
		<TabsPrimitive.List
			data-slot="tabs-list"
			className={cn(
				'inline-flex w-fit max-w-full items-center gap-2 rounded-lg bg-transparent p-0 text-muted-foreground',
				className
			)}
			{...props}
		/>
	)
}

export const TabsTrigger = ({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) => {
	return (
		<TabsPrimitive.Trigger
			data-slot="tabs-trigger"
			className={cn(
				'inline-flex min-w-20 items-center justify-center gap-1 rounded-lg border border-transparent bg-muted px-2 py-1 text-sm font-medium whitespace-nowrap text-muted-foreground transition-[color,background-color,box-shadow] data-[state=active]:bg-primary data-[state=active]:text-background data-[state=active]:shadow-sm data-[state=inactive]:bg-muted focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&>[data-slot=tabs-badge]]:inline-flex [&>[data-slot=tabs-badge]]:h-5 [&>[data-slot=tabs-badge]]:min-w-5 [&>[data-slot=tabs-badge]]:items-center [&>[data-slot=tabs-badge]]:justify-center [&>[data-slot=tabs-badge]]:rounded-full [&>[data-slot=tabs-badge]]:px-1.5 [&>[data-slot=tabs-badge]]:text-xs [&>[data-slot=tabs-badge]]:font-semibold [&>[data-slot=tabs-badge]]:bg-muted-foreground/20 [&>[data-slot=tabs-badge]]:text-muted-foreground data-[state=active]:[&>[data-slot=tabs-badge]]:bg-background data-[state=active]:[&>[data-slot=tabs-badge]]:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=size-])]:size-4',
				className
			)}
			{...props}
		/>
	)
}

export const TabsBadge = ({
	className,
	...props
}: React.ComponentProps<'span'>) => {
	return <span data-slot="tabs-badge" className={cn(className)} {...props} />
}

export const TabsContent = ({
	className,
	...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) => {
	return (
		<TabsPrimitive.Content
			data-slot="tabs-content"
			className={cn('flex-1 mt-2 outline-none', className)}
			{...props}
		/>
	)
}
